import React, { useState } from "react";
import SequenceUtils from "Utils/SequenceUtils";

const c = n => `${n} ${n === 1 ? "contact" : "contacts"}`;

const AddToSequenceResultBody = ({
  processed = 0,
  failedCount = 0,
  reasons = []
}) => {
  const [showMore, setShowMore] = useState(false);
  const labels = SequenceUtils.ADD_TO_SEQ_REASON_LABELS;
  const headline =
    processed > 0
      ? `${c(processed)} added to sequence successfully. Failed to add ${c(
          failedCount
        )}. `
      : `Failed to add ${c(failedCount)}. `;

  return (
    <div>
      <span>{headline}</span>
      <span className="linkHighLight" onClick={() => setShowMore(!showMore)}>
        {showMore ? "View less" : "View more"}
      </span>
      {showMore && (
        <div className="failureResponseMsg textLeft">
          <div className="leftBorder" />
          {reasons.map(r => (
            <div key={r.key}>{`${c(r.count)}: ${labels[r.key] || r.key}`}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export { AddToSequenceResultBody };
